import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./index.css";
import { WhiteLabelContext } from "../../../context/WhiteLabelProvider";

const Loading = () => {
  const {theme} = React.useContext(WhiteLabelContext);
  return (
    <div className="loading-container">
      <CircularProgress style={{color: theme.primary_color}} />
    </div>
  );
};

export default Loading;
